import React from 'react';
import { Button } from 'react-toolbox/lib/button';
import { connect } from 'react-redux';
import ReactMarkdown from 'react-markdown';
import {
    broadcastMessage,
    changeEntityOfTerminalTicket,
    closeTerminalTicket,
    getEntityScreenItems,
    postRefresh
} from '../../queries';
import * as Actions from '../../actions';
import PureRenderMixin from 'react-addons-pure-render-mixin';

class EntityListButton extends React.Component {

    constructor(props) {
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    render() {
        const style = {
            'color': this.props.labelColor,
            'backgroundColor': this.props.color,
            'margin': '4px',
            'height': 'auto',
            'minHeight': '65px',
            'flex': '1 1 11%',
            'lineHeight': '1.3',
            'wordWrap': 'breakWord',
            'whiteSpace': 'normal'
        };

        return (
            <Button
                style={style}
                className='entityButton'
                disabled={this.props.disabled}
                onClick={this.props.onClick}>
                <ReactMarkdown source={this.props.caption} />
            </Button>
        );
    }

}

class EntityList extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            isBusy: false,
            busyMessage: '',
            searchText: ''
        };
    }

    onSearchChange = (e) => {
        this.setState({ searchText: e.target.value });
    }

    startBusy = (message = 'İşlem yapılıyor...') => {
        if (this.busyTimer) clearTimeout(this.busyTimer);

        this.setState({
            isBusy: true,
            busyMessage: message
        });

        this.busyTimer = setTimeout(() => {
            this.stopBusy();
        }, 15000);
    }

    stopBusy = () => {
        if (this.busyTimer) {
            clearTimeout(this.busyTimer);
            this.busyTimer = null;
        }

        this.setState({
            isBusy: false,
            busyMessage: ''
        });
    }

    loadItems(name) {
        this.startBusy('Masalar yükleniyor...');

        this.props.loadEntityScreenRequest(name);

        getEntityScreenItems(name, (items) => {
            this.props.loadEntityScreenSuccess(name, items);
            this.stopBusy();
        });
    }

    componentDidMount() {
        this.loadItems(this.props.location.query.screenName);
    }

    componentWillUnmount() {
        if (this.busyTimer) {
            clearTimeout(this.busyTimer);
            this.busyTimer = null;
        }
    }

    render() {
        if (!this.props.items) {
            return (
                <div style={{ position: 'relative', height: '100%' }}>
                    <p>Loading...</p>

                    {this.state.isBusy &&
                        <div className="busyOverlay">
                            <div className="busyBox">
                                <div className="busySpinner"></div>
                                <div className="busyText">{this.state.busyMessage}</div>
                            </div>
                        </div>
                    }
                </div>
            );
        }

        const searchText = (this.state.searchText || '').toLocaleLowerCase('tr-TR');

        const filteredItems = (this.props.items || []).filter(x => {
            const name = (x.name || '').toLocaleLowerCase('tr-TR');
            const caption = (x.caption || '').toLocaleLowerCase('tr-TR');

            return !searchText ||
                name.indexOf(searchText) > -1 ||
                caption.indexOf(searchText) > -1;
        });

        const hasSelectedTable = this.hasSelectedTable(this.props.ticket);

        return (
            <div style={{ position: 'relative', height: '100%' }}>

                <input
                    type="text"
                    placeholder="Masa ara..."
                    value={this.state.searchText}
                    onChange={this.onSearchChange}
                    className="entitySearchInput"
                />
                <div className="entityList">
                    {filteredItems.map(x =>
                        <EntityListButton
                            key={x.name}
                            caption={x.caption}
                            labelColor={x.labelColor}
                            color={x.color}
                            disabled={hasSelectedTable}
                            onClick={(e) => this.selectEntity(x.name)}
                        />
                    )}
                </div>

                {this.state.isBusy &&
                    <div className="busyOverlay">
                        <div className="busyBox">
                            <div className="busySpinner"></div>
                            <div className="busyText">{this.state.busyMessage}</div>
                        </div>
                    </div>
                }
            </div>
        );
    }

    selectEntity = (entityName) => {
        if (this.hasSelectedTable(this.props.ticket)) {
            this.props.updateMessage('Bu sipariş için masa zaten seçilmiş.');
            this.context.router.push('/');
            return;
        }

        this.startBusy('Masa seçiliyor...');

        changeEntityOfTerminalTicket(
            this.props.location.query.terminalId,
            'Tables',
            entityName,
            (ticket) => {
                if (this.shouldCloseTicketAfterSelect()) {
                    this.closeSelectedTicket(ticket);
                    return;
                }

                this.props.setTicket(ticket);
                this.stopBusy();
                this.context.router.push('/');
            }
        );
    }

    shouldCloseTicketAfterSelect = () => {
        const query = this.props.location && this.props.location.query
            ? this.props.location.query
            : {};

        return query.afterSelect === 'closeTicket';
    }

    closeSelectedTicket = (ticket) => {
        this.startBusy('Sipariş kapatılıyor...');

        closeTerminalTicket(this.props.location.query.terminalId, (errorMessage) => {
            try {
                postRefresh();
                broadcastMessage('{"eventName":"TASK_PRINTED","terminal":"Server","userName":"Administrator","productType":"Food"}');

                if (ticket && ticket.id == 0) {
                    this.props.updateMessage('Sipariş başarılı bir şekilde gönderildi!');
                } else {
                    this.props.updateMessage('Sipariş işlemi tamamlandı.');
                }

                this.props.setTicket(undefined);

                if (this.props.ticketsNeedsRefresh) {
                    this.props.ticketsNeedsRefresh();
                }

                this.context.router.push('/');
            } finally {
                this.stopBusy();
            }
        });
    }

    hasSelectedTable = (ticket) => {
        return !!(
            ticket &&
            ticket.entities &&
            ticket.entities.some(x => x.type === 'Masalar')
        );
    }
}

EntityList.contextTypes = {
    router: React.PropTypes.object
};

const mapStateToProps = state => ({
    name: state.entityList.get('name'),
    isFetching: state.entityList.get('isFetching'),
    items: state.entityList.get('items'),
    ticket: state.app.get('ticket')
});

const mapDispatchToProps = ({
    loadEntityScreenRequest: Actions.loadEntityScreenRequest,
    loadEntityScreenSuccess: Actions.loadEntityScreenSuccess,
    setTicket: Actions.setTicket,
    ticketsNeedsRefresh: Actions.ticketsNeedsRefresh,
    updateMessage: Actions.updateMessage
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(EntityList);



// WEBPACK FOOTER //
// ./app/components/Entities/EntityList.jsx